import { BehaviorSubject, Subject } from 'rxjs';

export const pwaInstallPromtTrigger = new Subject<void>();
export const pwaReadyTrigger = new BehaviorSubject<boolean>(false);

export const listenForPwaInstallPrompt = () => {
  window.addEventListener('beforeinstallprompt', (event: any) => {
    pwaReadyTrigger.next(true);
    pwaInstallPromtTrigger.subscribe(() => {
      event.prompt();
    });
  });
};
